module.exports = __webpack_public_path__ + "img/ac460c902da249d2b06d812e3e43cff9.112a14d5.png";